import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "auth-form auth-loading" }
const _hoisted_2 = {
  key: 0,
  class: "auth-loading__content"
}
const _hoisted_3 = { class: "auth-loading__message" }
const _hoisted_4 = {
  key: 1,
  class: "auth-loading__content"
}
const _hoisted_5 = { class: "auth-loading__error-message" }

import Button from 'primevue/button';


export default /*@__PURE__*/_defineComponent({
  __name: 'AuthLoadingState',
  props: {
    message: { default: 'Redirecting…' },
    hasError: { type: Boolean, default: false },
    errorMessage: { default: 'Something went wrong. Please try again.' },
    showRetry: { type: Boolean, default: true }
  },
  emits: ["retry"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.hasError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "auth-loading__spinner" }, [
            _createElementVNode("div", { class: "auth-loading__ring" })
          ], -1)),
          _createElementVNode("p", _hoisted_3, _toDisplayString(__props.message), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "auth-loading__error-icon" }, [
            _createElementVNode("i", { class: "pi pi-exclamation-circle" })
          ], -1)),
          _createElementVNode("p", _hoisted_5, _toDisplayString(__props.errorMessage), 1),
          (__props.showRetry)
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 0,
                label: "Try Again",
                severity: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('retry')))
              }))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})